import { Switch } from '../../cdl/Switch/Switch';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import { checkPreference, flag } from '../../flags';

interface ToggleProps {
    name: string;
    onSelect: (name: string, checked: boolean) => void;
    label: string;
    description?: string;
}

const Toggle = ({ name, onSelect, label, description }: ToggleProps) => {
    const checked = checkPreference(name);
    const onChange = (checked: boolean) => onSelect(name, checked);

    return <Switch checked={checked} label={label} description={description} onChange={onChange} />;
};

export const DevFlags = () => {
    const updateToggle = (key: string, checked: boolean) => flag(key, checked);

    return (
        <Box display="flex" flexDirection="column" rowGap={6}>
            <Text variant="subtitle1" as="h3" marginBottom={8}>
                {translate('devTools.devFlags.headline')}
            </Text>
            <Box display="flex" flexDirection="column" rowGap={4}>
                <Toggle
                    name="FormikDebugTools"
                    label={translate('devTools.devFlags.formikDebugTools.label')}
                    description={translate('devTools.devFlags.formikDebugTools.description')}
                    onSelect={updateToggle}
                />
                <Toggle
                    name="PreferredNumberOfPoints"
                    label={translate('devTools.devFlags.avgConsumptionConfigControls.label')}
                    description={translate('devTools.devFlags.avgConsumptionConfigControls.description')}
                    onSelect={updateToggle}
                />
            </Box>
        </Box>
    );
};
